var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"is-relative"},[_c('img',{staticClass:"top",attrs:{"src":"/images/home/metaba-njpw2-top.png","alt":"着せ替え可能なNFTアバターサービス"}})])}]

export { render, staticRenderFns }